import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/*
 * Copyright (C) 2015 - 2018 Kosmos contact@kosmos.fr
 *
 * Projet: eprivacy
 * Version: 7.3.0-ALPHA-3
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *         http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import React from 'react';
import ConsentNoticeWrapper from './consent-notice-wrapper';
import ConsentModal from './consent-modal';
var Main = /*#__PURE__*/function (_React$Component) {
  function Main(props) {
    var _this;
    _classCallCheck(this, Main);
    _this = _callSuper(this, Main, [props]);
    _this.state = {
      isModalVisible: _this.isModalVisible()
    };
    _this.showModal = _this.showModal.bind(_this);
    _this.hideModal = _this.hideModal.bind(_this);
    _this.saveAndHideAll = _this.saveAndHideAll.bind(_this);
    _this.declineAndHideAll = _this.declineAndHideAll.bind(_this);
    _this.acceptAndHideAll = _this.acceptAndHideAll.bind(_this);
    return _this;
  }
  _inherits(Main, _React$Component);
  return _createClass(Main, [{
    key: "isModalVisible",
    value: function isModalVisible(userRequest) {
      var _this$props = this.props,
        config = _this$props.config,
        manager = _this$props.manager;
      if (userRequest) {
        return true;
      }
      if (config.mustConsent && (!manager.confirmed || manager.changed)) {
        return true;
      }
      return false;
    }
  }, {
    key: "isNoticeVisible",
    value: function isNoticeVisible() {
      var _this$props2 = this.props,
        config = _this$props2.config,
        manager = _this$props2.manager;
      if (config.mustConsent || config.noNotice) {
        return false;
      }
      if (manager.confirmed && !manager.changed) {
        return false;
      }
      if (manager.canBypassConsent()) {
        return false;
      }
      return true;
    }
  }, {
    key: "showModal",
    value: function showModal(e) {
      if (e !== undefined) {
        e.preventDefault();
      }
      this.setState({
        isModalVisible: this.isModalVisible(true)
      });
    }
  }, {
    key: "hideModal",
    value: function hideModal(e) {
      if (e !== undefined) {
        e.preventDefault();
      }
      this.setState({
        isModalVisible: this.isModalVisible(false)
      });
    }
  }, {
    key: "saveAndHideAll",
    value: function saveAndHideAll(e) {
      if (e !== undefined) {
        e.preventDefault();
      }
      this.props.manager.saveAndApplyConsents();
      this.setState({
        isModalVisible: this.isModalVisible(false)
      });
    }
  }, {
    key: "declineAndHideAll",
    value: function declineAndHideAll(e) {
      this.props.manager.declineAll();
      this.props.manager.saveAndApplyConsents();
      this.setState({
        isModalVisible: this.isModalVisible(false)
      });
    }
  }, {
    key: "acceptAndHideAll",
    value: function acceptAndHideAll(e) {
      this.props.manager.acceptAll();
      this.props.manager.saveAndApplyConsents();
      this.setState({
        isModalVisible: this.isModalVisible(false)
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
        config = _this$props3.config,
        t = _this$props3.t,
        manager = _this$props3.manager,
        ns = _this$props3.ns;
      var isNoticeVisible = this.isNoticeVisible();
      return /*#__PURE__*/React.createElement("div", {
        className: ns('Main')
      }, /*#__PURE__*/React.createElement(ConsentNoticeWrapper, {
        key: "notice",
        t: t,
        ns: ns,
        isVisible: isNoticeVisible,
        isMandatory: config.mustNotice || false,
        isModalVisible: this.state.isModalVisible,
        config: config,
        manager: manager,
        onSaveRequest: this.acceptAndHideAll,
        onDeclineRequest: this.declineAndHideAll,
        onConfigRequest: this.showModal
      }), /*#__PURE__*/React.createElement(ConsentModal, {
        key: "modal",
        isOpen: this.state.isModalVisible,
        t: t,
        ns: ns,
        config: config,
        onHideRequest: this.hideModal,
        onSaveRequest: this.saveAndHideAll,
        manager: manager
      }));
    }
  }]);
}(React.Component);
export { Main as default };